import { Box, Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { ReportHeading } from '../common/ReportHeading'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import * as id from '../reportId'
import * as lb from '../reportLables'
import moment from 'moment'
import { connect, useDispatch, useSelector } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import { focusElemnt, getInt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import { RefreshSvg } from '../../../common/svg/refresh'
import {
  getCargoSettingFilterData,
  getFranchiseOutstandingTableData,
  getFranchiseOutstandingTableFiltersData,
} from '../../../../store/reports/reports_action'
import FranchiseOutstandingReportTable from './FranchiseOutstandingReportTable'
import { PDFHeaderColumns, PDFHeaderDetailedColumns, reportViewData } from './constants'
import FranchiseOutstandingReportDetailedTable from './FranchiseOutstandingReportDetailedTable'
import FranchiseOutstandingReportBothTable from './FranchiseOutstandingReportBothTable'
import { useAtom } from 'jotai'
import { alertAtom } from '../../../common/jotaiState/globalStateAtoms'
import { SELECT, urls } from '../../../common/constants'
import { paymentModesWithAll } from '../../../common/paymentsMode'
import DropDownMultiSelectV2 from '../../../common/dropDownMultiSelectV2'
import { updateLoader } from '../../../../store/common/common_action'
import { GetRequest } from '../../../common/api'
import Alert from '../../../common/alert'


const FranchiseOutstandingReport = (props) => {
  const { updateLoader, } = props
  const state = useSelector((state) => state)
  const { common, reports } = state
  const { loginData, roleRights, companySettings } = common
  const UseToPayAsCOD = companySettings[0]?.UseToPayAsCOD
  const { franchiseOutstandingTableFilterData, franchiseOutstandingTableData } = reports

  const dispatch = useDispatch()
  const { } = reports
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [showTable, setShowTable] = useState(false)
  const [, setAlert] = useAtom(alertAtom)

  const [tableData, setTableData] = useState([])
  const [disableGoBtn, setDisableGoBtn] = useState(false)
  const [tableDetailedData, setTableDetailedData] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [sourceBranch, setSourceBranch] = useState('')
  const [selSourceCity, setSelSourceCity] = useState('')
  const [sourceCityData, setSourceCityData] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState('')
  const [sourceBranchDataAll, setSourceBranchDataAll] = useState([])
  const [sourceBranchData, setSourceBranchData] = useState([])
  const [selDestinationCity, setSelDestinationCity] = useState('')
  const [destinationCityData, setDestinationCityData] = useState([])
  const [selDestinationBranch, setSelDestinationBranch] = useState('')
  const [destinationBranchData, setDestinationBranchData] = useState([])
  const [destinationBranchDataAll, setDestinationBranchDataAll] = useState([])
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: ''
  })
  const paymentList = paymentModesWithAll.map((item) => {
    if (UseToPayAsCOD === 1) {
      if (item.typeId === 2) {
        return { ...item, name: 'COD' };
      }
      if (item.typeId === 7) {
        return { ...item, name: 'COD Manual' };
      }
      if (item.typeId === 9) {
        return { ...item, name: 'COD DDDV' };
      }
      if (item.typeId === 4) {
        return null;
      }
    }
    return { ...item, checked: true };
  }).filter(Boolean)
  const [paymentType, setPaymentType] = useState(paymentList)
  const [reportView, setReportView] = useState(reportViewData?.[0])
  const criteriaHeaders = [
    { field: 'fromDate', header: 'From Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Date', textAlign: 'left' },
    { field: 'sourceCity', header: 'Source Franchise City', textAlign: 'left' },
    { field: 'sourceBranch', header: 'Source Franchise Branch', textAlign: 'left' },
    { field: 'destinationCity', header: 'Destination City', textAlign: 'left' },
    { field: 'destinationBranch', header: 'Destination Branch', textAlign: 'left' },
    { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
    { field: 'reportView', header: 'Report View', textAlign: 'left' },
  ]
  const paymentValue = paymentType.length === paymentList.length
    ? 'All Payment Type'
    : paymentType.length === 1
      ? paymentType[0].name
      : paymentType.length > 1
        ? 'MultiSelect'
        : '';
  const criteriaData = {
    company: loginData.strCompanyName,
    toDate: moment(toDate).format('DD-MMM-YYYY'),
    fromDate: moment(fromDate).format('DD-MMM-YYYY'),
    sourceCity: selSourceCity?.FranchiseeCityName,
    sourceBranch: selSourceBranch?.SourceBranch,
    destinationCity: selDestinationCity?.DestinationCity,
    destinationBranch: selDestinationBranch?.DestinationBranch,
    paymentType: paymentValue,
    reportView: reportView?.view,
    dataType: 'entry'
  }

  const updatedPDFHeaderColumns = (PDFHeaderColumns || []).map((col) => {
    if (UseToPayAsCOD === 1) {
      switch (col.field) {
        case 'TotalToPayBookings':
          return { ...col, header: 'Total COD Bookings', exportHead: 'Total COD Bookings' };
        case 'TotalToPayDeliveries':
          return { ...col, header: 'Total COD Deliveries', exportHead: 'Total COD Deliveries' };
        default:
          return col;
      }
    }
    return col;
  });

  // const paymentList = paymentModesWithAll.map((item) => ({ ...item, checked: true }))

  const reportName = 'Franchise Outstanding'
  const headerData = {
    company: loginData.strCompanyName,
    toDate: moment(toDate).format('DD-MMM-YYYY'),
    fromDate: moment(fromDate).format('DD-MMM-YYYY'),
    sourceCity: selSourceCity?.FranchiseeCityName,
    sourceBranch: selSourceBranch?.SourceBranch,
    destinationCity: selDestinationCity?.DestinationCity,
    destinationBranch: selDestinationBranch?.DestinationBranch,
    paymentType: paymentType.filter(p => p.checked).map(p => p.name).join(', '),
    reportView: reportView?.view,
  }

  const callFilterAPi = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      const obj = {
        CompanyID: loginData?.intCompanyID,
        FromDate: moment(fromDate).format('YYYY-MM-DD'),
        ToDate: moment(toDate).format('YYYY-MM-DD'),
      }
      dispatch(getFranchiseOutstandingTableFiltersData(obj))
    }
  }

  const reset = () => {
    setPaymentType(paymentList)
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSourceBranch(' ')
    setShowTable(false)
  }

  // useEffect(() => {
  //   if (franchiseOutstandingTableData?.Data?.table?.length > 0 || franchiseOutstandingTableData?.Data?.table1?.length > 0) {
  //     const selectedTypes = paymentType.filter(p => p.checked).map((pt) => pt.typeId) || []
  //     const summaryTableData = franchiseOutstandingTableData?.Data?.table.map((item) => ({ ...item, PaymentType: UseToPayAsCOD === 1 && item.PaymentTypeID === 2 ? 'COD' : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PaymentTypeID === 9 ? 'COD(DDDV)' : item.PaymentType }))
  //     const detaileTableData = franchiseOutstandingTableData?.Data?.table1.map((item) => ({ ...item, PaymentType: UseToPayAsCOD === 1 && item.PaymentTypeID === 2 ? 'COD' : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PaymentTypeID === 9 ? 'COD(DDDV)' : item.PaymentType }))
  //     if (reportView.view !== 'Summary & Detailed') {
  //       let data = reportView.view === 'Summary' ? summaryTableData : detaileTableData
  //       let filtData = []
  //       if (selectedTypes.includes(0)) {
  //         filtData = data
  //       } else {
  //         filtData = data.filter((item) => selectedTypes.includes(item.PaymentTypeID))
  //       }
  //       const filtPaymentTypeData = filtData.map((item) => ({
  //         ...item,
  //         isDataRow: true,
  //       }))

  //       setTableData(filtPaymentTypeData)
  //     } else {
  //       let summaryData = summaryTableData
  //       let detailedData = detaileTableData
  //       const filtSummaryData = selectedTypes.includes(0)
  //         ? summaryData
  //         : summaryData.filter((item) => selectedTypes.includes(item.PaymentTypeID))

  //       const filtDetailedData = selectedTypes.includes(0)
  //         ? detailedData
  //         : detailedData.filter((item) => selectedTypes.includes(item.PaymentTypeID))

  //       const mappedSummaryData = filtSummaryData.map((item) => ({
  //         ...item,
  //         isDataRow: true,
  //       }))

  //       const mappedDetailedData = filtDetailedData.map((item) => ({
  //         ...item,
  //         isDataRow: true,
  //       }))

  //       setTableData(mappedSummaryData)
  //       setTableDetailedData(mappedDetailedData)
  //     }
  //     setShowTable(true)
  //   }
  // }, [franchiseOutstandingTableData])

  useEffect(() => {
    focusElemnt('fromDate')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID,
      }
      getCargoSettingFilterData(obj)
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
      setDisableExcel(!roleRights?.Table1?.[0]?.AllowExportExcel)
    }
  }, [roleRights, loginData])

  useEffect(() => {
    if (!isEmpty(franchiseOutstandingTableFilterData)) {
      if (franchiseOutstandingTableFilterData?.Data?.table?.length > 0) {
        let data = []
        let data1 = []
        let data2 = []
        let data3 = []
        const set1 = new Set()
        const set2 = new Set()
        const set3 = new Set()
        const set4 = new Set()
        franchiseOutstandingTableFilterData?.Data?.table?.map((val, i) => {
          if (!set1.has(val?.FranchiseeCityID)) {
            set1.add(val?.FranchiseeCityID)
            data.push({
              FranchiseeCityName: val?.FranchiseeCityName,
              FranchiseeCityID: val?.FranchiseeCityID,
              FranchiseComapnyID: val.FranchiseComapnyID,
            })
          }
          if (!set2.has(val?.FranchiseeBranchID)) {
            set2.add(val?.FranchiseeBranchID)
            data1.push({
              SourceBranch: val?.FranchiseeBranchName,
              FranchiseeBranchID: val?.FranchiseeBranchID,
              FranchiseeCityName: val?.FranchiseeCityName,
              SourceCityID: val?.FranchiseeCityID,
              FranchiseComapnyID: val.FranchiseComapnyID,
            })
          }
          if (!set3.has(val?.DestinationCityID)) {
            set3.add(val?.DestinationCityID)
            data2.push({
              DestinationCity: val?.DestinationCityName,
              DestinationCityID: val?.DestinationCityID,
              FranchiseeCityName: val.FranchiseeCityName,
              DestinationCompanyID: val.DestinationCompanyID,
            })
          }
          if (!set4.has(val?.DestinationBranchID)) {
            set4.add(val?.DestinationBranchID)
            data3.push({
              DestinationBranch: val?.DestinationBranchName,
              DestinationBranchID: val?.DestinationBranchID,
              DestinationCity: val?.DestinationCityName,
              DestinationCompanyID: val.DestinationCompanyID,
              DestinationCityID: val?.DestinationCityID,
            })
          }
        })
        if (data.length > 1) {
          data.unshift({ FranchiseeCityName: 'All Cities', FranchiseeCityID: 0 })
        }
        setSourceCityData(data)
        //const data1filter = data1.filter((item) => item?.FranchiseComapnyID !== loginData?.intCompanyID)
        const data1filter = data1.filter((item) => item?.FranchiseComapnyID === loginData?.intCompanyID)
        setSourceBranchData(data1filter)
        if (data1.length > 1) {
          data1.unshift({ SourceBranch: 'All Branches', FranchiseeBranchID: 0 })
        }
        setSourceBranchDataAll(data1)
        setDestinationCityData([{ DestinationCity: 'All Cities', DestinationCityID: 0 }, ...data2])
        // const data3filter = data3.filter((item) => item?.DestinationCompanyID !== loginData?.intCompanyID)
        const data3filter = data3.filter((item) => item?.DestinationCompanyID === loginData?.intCompanyID)
        setDestinationBranchData(data3filter)
        if (data3.length > 1) {
          data3.unshift({ DestinationBranch: 'All Branch', DestinationBranchID: 0 })
        }
        setDestinationBranchDataAll(data3)
        if (disableBtn) {
          setSelSourceCity({ FranchiseeCityName: loginData?.strCityName, FranchiseeCityID: loginData?.intBranchCityID })
          setSelSourceBranch({ SourceBranch: loginData?.strBranchName, FranchiseeBranchID: loginData?.intBranchID })
        } else {
          setSelSourceCity({ FranchiseeCityName: 'All Cities', FranchiseeCityID: 0 })
          data1.length > 1
            ? setSelSourceBranch({ SourceBranch: 'All Branches', FranchiseeBranchID: 0 })
            : data1.length === 1
              ? setSelSourceBranch(data1[0])
              : setSelSourceBranch('')
        }
        setSelDestinationCity({ DestinationCity: 'All Cities', DestinationCityID: 0 })
        setSelDestinationBranch({ DestinationBranch: 'All Branch', DestinationBranchID: 0 })
      } else {
        setSourceCityData([])
        setSourceBranchData([])
        setDestinationCityData([])
        setDestinationBranchData([])
        setSelSourceCity(' ')
        setSelSourceBranch(' ')
        setSelDestinationCity('  ')
        setSelDestinationBranch(' ')
      }
    }
  }, [franchiseOutstandingTableFilterData])
  const formatTableDataForBoth = (table = [], table1 = []) => {
    if (table?.length > 0 || table1?.length > 0) {
      let selectedTypes = paymentType.filter(p => p.checked).map((pt) => pt.typeId) || []
      if (paymentType.length === 11) {
        selectedTypes = Array.from({ length: 10 }, (_, i) => i + 1); // [1,2,...,10]
      }
      const summaryTableData = table.map((item) => ({ ...item, PaymentType: UseToPayAsCOD === 1 && item.PaymentTypeID === 2 ? 'COD' : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PaymentTypeID === 9 ? 'COD(DDDV)' : item.PaymentType }))
      const detaileTableData = table1.map((item) => ({ ...item, PaymentType: UseToPayAsCOD === 1 && item.PaymentTypeID === 2 ? 'COD' : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PaymentTypeID === 9 ? 'COD(DDDV)' : item.PaymentType }))

      let summaryData = summaryTableData
      let detailedData = detaileTableData
      const filtSummaryData = selectedTypes.includes(0)
        ? summaryData
        : summaryData.filter((item) => selectedTypes.includes(item.PaymentTypeID))

      const filtDetailedData = selectedTypes.includes(0)
        ? detailedData
        : detailedData.filter((item) => selectedTypes.includes(item.PaymentTypeID))
      if (filtSummaryData?.length === 0 && filtDetailedData?.length === 0) {
        setShowAlert({ show: true, message: 'No Data Found!' })
        return
      }
      const mappedSummaryData = filtSummaryData.map((item) => ({
        ...item,
        //isDataRow: true,
      }))
      const mappedDetailedData = filtDetailedData.map((item) => ({
        ...item,
        //  isDataRow: true,
      }))
      return {
        summary: mappedSummaryData,
        detailed: mappedDetailedData,
      }
    }
  }
  const formatTableData = (table = [], table1 = []) => {
    if (table?.length > 0 || table1?.length > 0) {
      let selectedTypes = paymentType.filter(p => p.checked).map((pt) => pt.typeId) || []
      if (paymentType.length === 11) {
        selectedTypes = Array.from({ length: 10 }, (_, i) => i + 1); // [1,2,...,10]
      }
      const summaryTableData = table.map((item) => ({ ...item, PaymentType: UseToPayAsCOD === 1 && item.PaymentTypeID === 2 ? 'COD' : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PaymentTypeID === 9 ? 'COD(DDDV)' : item.PaymentType }))
      const detaileTableData = table1.map((item) => ({ ...item, PaymentType: UseToPayAsCOD === 1 && item.PaymentTypeID === 2 ? 'COD' : item.PaymentTypeID === 7 ? 'COD(MANUAL)' : item.PaymentTypeID === 9 ? 'COD(DDDV)' : item.PaymentType }))
      let data = reportView.view === 'Summary' ? summaryTableData : detaileTableData
      let filtData = []
      if (selectedTypes.includes(0)) {
        filtData = data
      } else {
        filtData = data.filter((item) => selectedTypes.includes(item.PaymentTypeID))
      }
      if (filtData?.length === 0) {
        setShowAlert({ show: true, message: 'No Data Found!' })
        return
      }
      const filtPaymentTypeData = filtData.map((item) => ({
        ...item,
        // isDataRow: true,
      }))
      return filtPaymentTypeData
    }
  }

  const formatGroupedTableDataForDetailed = (tablesData) => {
    if (!Array.isArray(tablesData) || tablesData.length === 0) return [];
    const grouped = {};
    // Group by Source + Destination combo
    for (const item of tablesData) {
      const srcKey = `${item.BookingCityName || ''}__${item.BranchName || ''}`;
      const destKey = `${item.DestinationCityName || ''}__${item.DestinationBranchName || ''}`;
      const groupKey = `${srcKey}::${destKey}`;

      if (!grouped[groupKey]) grouped[groupKey] = [];
      grouped[groupKey].push(item);
    }
    const result = [];
    let serialNo = 1;
    let grandTotalItems = 0;
    let grandTotalAmount = 0;
    for (const groupKey in grouped) {
      const [src, dest] = groupKey.split('::');
      const [srcCity, srcBranch] = src.split('__');
      const [destCity, destBranch] = dest.split('__');
      result.push({
        dataType: 'subHeader',
        SN: `Source City : ${srcCity}`,
        SenNameMob: `Destination City : ${destCity}`,
        colSpan: { 'SN': 5, 'SenNameMob': 6 },
        align: { 'SN': 'left', 'SenNameMob': 'right', },
      });
      let groupItemsTotal = 0;
      let groupAmountTotal = 0;

      for (const item of grouped[groupKey]) {
        const row = {
          dataType: 'entry',
          SN: serialNo++,
          LRManLRno: item.LRNO || '',
          BKGDateTime: item.BookingDate || '',
          SrcCityBranch: `${item.BookingCityName || ''}\n${item.BranchName || ''}`,
          DestCityBranch: `${item.DestinationCityName || ''}\n${item.DestinationBranchName || ''}`,
          SenNameMob: `${item.SenderName || ''}\n${item.SenderMobileNo || ''}`,
          RecNameMob: `${item.RecName || ''}\n${item.RecMobileNo || ''}`,
          PaymentType: item.PaymentType || '',
          Status: item.LRStatus || '',
          Items: item.Items || 0,
          NetAmount: item.GrossAmount || 0
        };

        groupItemsTotal += row.Items;
        groupAmountTotal += row.NetAmount;
        result.push(row);
      }
      result.push({
        dataType: 'total',
        Status: 'Total',
        Items: groupItemsTotal,
        NetAmount: groupAmountTotal
      });
      grandTotalItems += groupItemsTotal;
      grandTotalAmount += groupAmountTotal;
    }
    result.push({
      dataType: 'total',
      Status: 'Grand Total',
      Items: grandTotalItems,
      NetAmount: grandTotalAmount
    });
    return result;
  }
  const formatGroupedTableDataForSummary = (tablesData) => {
    const groupedData = tablesData.reduce((acc, item) => {
      if (!acc[item.BranchName]) acc[item.BranchName] = []
      acc[item.BranchName].push(item)
      return acc
    }, {})

    const formattedData = []
    const grandTotal = {
      dataType: 'total',
      PaymentType: 'GROSS AMOUNT',
      //isTotal: true,
      GrossAmount: 0,
      GST: 0,
      TotalFreight: 0,
      FreightPercentage: 0,
      NetFreight: 0,
      TotalToPayBookings: 0,
      TotalToPayDeliveries: 0,
      TotalAmount: 0,
    }

    let serialNumber = 1

    Object.keys(groupedData).forEach((branch) => {
      formattedData.push({
        //   isSubHeading: true,
        dataType: 'subHeader',
        SN: `Franchisee: ${branch}`,
        colSpan: { 'SN': 10 },
        align: { 'SN': 'left' }
      })

      groupedData[branch].forEach((item) => {
        formattedData.push({ ...item, SN: serialNumber++, dataType: 'entry' })
      })

      const branchTotal = {
        dataType: 'total',
        PaymentType: 'TOTAL AMOUNT',
        //isTotal: true,
        GrossAmount: groupedData[branch].reduce((sum, item) => sum + item.GrossAmount, 0),
        GST: groupedData[branch].reduce((sum, item) => sum + item.GST, 0),
        TotalFreight: groupedData[branch].reduce((sum, item) => sum + item.TotalFreight, 0),
        FreightPercentage: groupedData[branch].reduce((sum, item) => sum + item.FreightPercentage, 0),
        NetFreight: groupedData[branch].reduce((sum, item) => sum + item.NetFreight, 0),
        TotalToPayBookings: groupedData[branch].reduce((sum, item) => sum + item.TotalToPayBookings, 0),
        TotalToPayDeliveries: groupedData[branch].reduce((sum, item) => sum + item.TotalToPayDeliveries, 0),
        TotalAmount: groupedData[branch].reduce((sum, item) => sum + item.TotalAmount, 0),
      }

      formattedData.push(branchTotal)

      grandTotal.GrossAmount += branchTotal.GrossAmount
      grandTotal.GST += branchTotal.GST
      grandTotal.TotalFreight += branchTotal.TotalFreight
      grandTotal.FreightPercentage += branchTotal.FreightPercentage
      grandTotal.NetFreight += branchTotal.NetFreight
      grandTotal.TotalToPayBookings += branchTotal.TotalToPayBookings
      grandTotal.TotalToPayDeliveries += branchTotal.TotalToPayDeliveries
      grandTotal.TotalAmount += branchTotal.TotalAmount
    })

    formattedData.push(grandTotal)

    return formattedData
  }
  const handleClick1 = () => {
    if (selSourceCity == '' || selSourceCity == ' ') {
      setAlert({ show: true, msg: 'Select Source City', nextId: '' })
    }
    if (selSourceBranch == '' || selSourceBranch == ' ' || selSourceBranch == undefined) {
      setAlert({ show: true, msg: 'Select Source Branch', nextId: '' })
    } else if (selDestinationBranch == '' || selDestinationBranch == ' ' || selDestinationBranch == undefined) {
      setAlert({ show: true, msg: 'Select Source Branch', nextId: '' })
    } else if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else if (franchiseOutstandingTableFilterData?.Data?.table?.length > 0) {
      const body = {
        CompanyID: loginData?.intCompanyID,
        FromDate: moment(fromDate).format('YYYY-MM-DD'),
        ToDate: moment(toDate).format('YYYY-MM-DD'),
        FranchiseCityID: selSourceCity?.FranchiseeCityID,
        FranchiseBranchID: selSourceBranch?.FranchiseeBranchID,
        ToCityID: selDestinationCity?.DestinationCityID,
        ToBranchID: selDestinationBranch?.DestinationBranchID,
      }
      updateLoader(true)
      GetRequest(urls.getFranchiseOutstandingTableData, body).then((res) => {
        if (res.status == 'Success') {
          updateLoader(false)
          const table = res?.Data?.table
          const table1 = res?.Data?.table1
          if (table?.length === 0 && table1?.length === 0) {
            setShowAlert({ show: true, message: 'No Data Found!' })
            return
          }
          const finalData = formatTableData(table, table1)
          let reportPayload = []
          let filteredDataDetailed = []
          let filteredDataSummary = []
          filteredDataDetailed = formatGroupedTableDataForDetailed(finalData);
          let mainHeaderDetailed = PDFHeaderDetailedColumns?.map((val) => ({
            ...val,
            field: val.field,
            align: val.align,
            export: val.exportHead,
            weight: 80,
            width: getInt(val.width),
          }))
          filteredDataSummary = formatGroupedTableDataForSummary(finalData);
          let mainHeaderSummary = updatedPDFHeaderColumns?.map((val) => ({
            ...val,
            field: val.field,
            align: val.align,
            export: val.exportHead,
            weight: 80,
            width: getInt(val.width),
          }))
          if (reportView.view === 'Detailed') {
            reportPayload = {
              reportName,
              criteriaHeaders: criteriaHeaders,
              criteriaData: [criteriaData],
              tableData: filteredDataDetailed,
              mainHeader: mainHeaderDetailed,
              serialNokey: 'SN',
            }
          } else if (reportView.view === 'Summary') {

            reportPayload = {
              reportName,
              criteriaHeaders: criteriaHeaders,
              criteriaData: [criteriaData],
              tableData: filteredDataSummary,
              mainHeader: mainHeaderSummary,
              serialNokey: 'SN',
            }
          } else {
            const { summary, detailed } = formatTableDataForBoth(table, table1)
            filteredDataDetailed = formatGroupedTableDataForDetailed(detailed);
            filteredDataSummary = formatGroupedTableDataForSummary(summary);

            reportPayload = {
              reportName,
              isMultiTable: true,
              tables: [
                {
                  reportName: 'Franchise Outstanding Report - Summary',
                  criteriaHeaders: criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: filteredDataSummary,
                  mainHeader: mainHeaderSummary,
                  serialNokey: 'SN',
                },
                {
                  reportName: "Franchise Outstanding Report - Detailed",
                  tableData: filteredDataDetailed,
                  mainHeader: mainHeaderDetailed,
                  serialNokey: 'SN',
                }
              ],
            }

          }
          const rid = Date.now().toString()
          if (!window.generatedReports) {
            window.generatedReports = {}
          }
          window.generatedReports[rid] = reportPayload
          window.open(`/view-report?rid=${rid}`, "_blank")
        }
        else {
          updateLoader(false)
          setShowAlert({ show: true, message: res?.ErrMessage })
        }
      }).catch((err) => {
        updateLoader(false)
        console.log('Error:', err)
      })
      //  dispatch(getFranchiseOutstandingTableData(body))//getFranchiseOutstandingTableData
    }
  }
  const selectedReportView = (value) => {
    setReportView(value)
    setShowTable(false)
  }

  const selectedSourceCity = (obj) => {
    setSelSourceCity(obj)
    if (obj.FranchiseeCityID) {
      const tempList = sourceBranchData.filter((a) => a.SourceCityID === obj?.FranchiseeCityID)
      setSelSourceBranch(tempList?.[0] || '')
      if (obj.FranchiseeCityID === selDestinationCity?.DestinationCityID) {
        selectedDestCity('')
      }
    } else {
      setSelSourceBranch(sourceBranchDataAll?.[0] || '')
    }
    setShowTable(false)
  }
  const selectedDestCity = (obj) => {
    setSelDestinationCity(obj)
    if (obj.DestinationCityID) {
      const tempList = destinationBranchData.filter(a => a.DestinationCityID === obj?.DestinationCityID)
      setSelDestinationBranch(tempList?.[0] || '')
    } else {
      setSelDestinationBranch(destinationBranchDataAll?.[0] || '')
    }
    setShowTable(false)
  }

  useEffect(() => {
    focusElemnt(id.fromDate)
  }, [])
  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx} style={{ width: '350px' }}>
            <DropDownOA
              id={id.selectCompnay}
              label={lb.select_company}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              width="100%"
            />{' '}
          </Item>
          <Item sx={sx.itemsx} style={{ width: '210px' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Date'}
              id={id.fromDate}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                focusElemnt(id.toDate)
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '210px' }} className="input--container bookingDatePicker">
            <Datepicker
              label={'To Date'}
              value={toDate}
              id={id.toDate}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                focusElemnt(id.anSourceCity)
              }}
              width="100%"
              dateDiff={730}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <Button
              variant="contained"
              style={{ ...sx.fullHeight, ...sx.novp }}
              id={id.goButton}
              disabled={disableGoBtn}
              className="btn btn-primary"
              onClick={callFilterAPi}
            >
              GO
            </Button>
          </Item>
          <Item sx={sx.itemsx} style={{ width: '300px' }}>
            <DropDownOA
              id={id.anSourceCity}
              label={'Source City'}
              searchPlaceholder={`Search Source City`}
              defaultvalue={selSourceCity?.FranchiseeCityName || SELECT}
              data={sourceCityData || []}
              listWidth="200px"
              width="100%"
              dataKey={`FranchiseeCityName`}
              idKey={`FranchiseeCityID`}
              disabled={disableBtn}
              onSelect={(obj) => selectedSourceCity(obj)}
              nextId={id.anSourceBranch}
              prevId={id.toDate}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '300px' }}>
            <DropDownOA
              id={id.anSourceBranch}
              label={'Source Branch'}
              searchPlaceholder={`Search Source Branch`}
              defaultvalue={selSourceBranch?.SourceBranch || SELECT}
              data={
                selSourceCity?.FranchiseeCityID
                  ? sourceBranchData.filter(
                    (a) =>
                      a.SourceCityID === selSourceCity?.FranchiseeCityID && a.FranchiseComapnyID === selSourceCity?.FranchiseComapnyID
                  )
                  : sourceBranchDataAll || []
              }
              width="100%"
              listWidth="200px"
              dataKey={`SourceBranch`}
              idKey={`FranchiseeBranchID`}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
              onSelect={(obj) => {
                setSelSourceBranch(obj)
                setShowTable(false)
              }}
              nextId={id.anDestinationCity}
              prevId={id.anSourceCity}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '250px' }}>
            <DropDownOA
              id={id.anDestinationCity}
              label={'Destination City'}
              searchPlaceholder={`Search Destination City`}
              defaultvalue={selDestinationCity?.DestinationCity || SELECT}
              data={destinationCityData.filter((a) => a.DestinationCityID !== selSourceCity?.FranchiseeCityID || !a.DestinationCityID)}
              width="100%"
              listWidth="200px"
              dataKey={`DestinationCity`}
              idKey={`DestinationCityID`}
              onSelect={(obj) => selectedDestCity(obj)}
              nextId={id.anDestinationCity}
              prevId={id.anSourceBranch}
            />
          </Item>

          <Item sx={sx.itemsx} style={{ width: '250px' }}>
            <DropDownOA
              id={id.anDestinationBranch}
              defaultvalue={selDestinationBranch?.DestinationBranch || SELECT}
              data={
                selDestinationCity?.DestinationCityID
                  ? destinationBranchData
                    .filter(
                      (a) =>
                        a.DestinationCityID === selDestinationCity?.DestinationCityID &&
                        a.DestinationCompanyID === selDestinationCity?.DestinationCompanyID
                    )
                  : destinationBranchDataAll.filter((a) => a.DestinationCityID !== selSourceCity?.FranchiseeCityID) || []
              }
              width="100%"
              searchPlaceholder={`Search Destination Branch`}
              label={'Destination Branch'}
              tabIndex="2"
              dataKey={`DestinationBranch`}
              idKey={`DestinationBranchID`}
              onSelect={(value) => {
                setSelDestinationBranch(value)
                setShowTable(false)
              }}
              nextId={id.anPaymentType}
              prevId={id.anDestinationCity}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '205px' }}>
            <DropDownMultiSelectV2
              id={id.anPaymentType}
              data={paymentList || []}
              defaultvalue={paymentType}
              width="100%"
              searchPlaceholder={`Search By Payment Type`}
              label={'Payment Type'}
              tabIndex="2"
              dataKey={`name`}
              HasAllSelect={true}
              idKey={`typeId`}
              onSelect={(value) => {
                setShowTable(false)
                setPaymentType(value)
              }}
              nextId={id.anView}
              prevId={id.anDestinationBranch}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '250px' }}>
            <DropDownOA
              id={id.anView}
              defaultvalue={reportView?.view}
              data={reportViewData}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`view`}
              idKey={`id`}
              onSelect={(value) => selectedReportView(value)}
              nextId={'SplitButton'}
              prevId={id.anPaymentType}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            onKeyDown={(e) =>
              navigation3(e, showTable ? (disableExcel ? 'ExportToPdf' : 'ExportToExl') : id.fromDate, id.anView, () => handleClick1())
            }
          >
            <Button
              variant="contained"
              id={'SplitButton'}
              onClick={handleClick1}
              className="btn btn-primary"
              style={{ padding: '7px 10px' }}
            >
              GENERATE NEW FORMAT
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
            <RefreshSvg width={'24px'} height={'24px'} />
          </Item>
        </Box>
      </Item>
      <Item>
        {showTable &&
          (() => {
            const CommonProps = {
              disableExcel,
              headerData,
              tablesData: tableData || [],
              sourceBranch,
            }

            return reportView.view === 'Summary' ? (
              <FranchiseOutstandingReportTable {...CommonProps} UseToPayAsCOD={UseToPayAsCOD} />
            ) : reportView.view === 'Detailed' ? (
              <FranchiseOutstandingReportDetailedTable {...CommonProps} />//
            ) : (
              <FranchiseOutstandingReportBothTable {...CommonProps} UseToPayAsCOD={UseToPayAsCOD} tablesDataDetailed={tableDetailedData} />
            )
          })()}
      </Item>
      {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateLoader }
export default connect(mapStateToProps, mapDispatchToProps)(FranchiseOutstandingReport)

// export default FranchiseOutstandingReport
